import { render, staticRenderFns } from "./Simulator_mobile.vue?vue&type=template&id=1dd5b8fd&scoped=true&"
import script from "./Simulator_mobile.vue?vue&type=script&lang=js&"
export * from "./Simulator_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Simulator_mobile.vue?vue&type=style&index=0&id=1dd5b8fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd5b8fd",
  null
  
)

export default component.exports